import React from 'react';
import Card from '../../components/ui/Card.jsx';
import Button from '../../components/ui/Button.jsx';
import { apiFetch } from '../../api.js';
import { useApi } from '../../hooks/useApi.js';
import { RouteContext } from '../../router.jsx';

export default function StaffEmailDetail({ params }) {
  const { navigate } = React.useContext(RouteContext);
  const emailId = params?.id;
  const { data, loading, error } = useApi(`/api/emails/${emailId}`, [emailId]);
  const [message, setMessage] = React.useState({ text: '', tone: 'info' });
  const [saving, setSaving] = React.useState(false);

  if (!emailId) {
    return (
      <div className="page">
        <div className="alert error">Missing email id.</div>
      </div>
    );
  }

  const handleDelete = async () => {
    if (!window.confirm('Delete this email log? This cannot be undone.')) return;
    setSaving(true);
    setMessage({ text: '', tone: 'info' });
    try {
      await apiFetch(`/api/emails/${emailId}`, { method: 'DELETE' });
      navigate('/staff/emails');
    } catch (err) {
      setMessage({ text: err?.message || 'Failed to delete email.', tone: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Email Detail</h1>
          <p className="subtle">Review the delivery payload and recipients.</p>
        </div>
        <div className="header-actions">
          <Button variant="secondary" type="button" onClick={() => navigate('/staff/emails')}>Back to Emails</Button>
          <Button variant="secondary" type="button" onClick={handleDelete} disabled={saving}>Delete</Button>
        </div>
      </div>

      {error ? <div className="alert error">{error}</div> : null}
      {message.text ? <div className={message.tone === 'error' ? 'alert error' : 'alert'}>{message.text}</div> : null}

      {loading || !data ? (
        <p className="subtle">Loading...</p>
      ) : (
        <div className="grid two">
          <Card title="Email Summary">
            <div className="summary-list">
              <div className="summary-row">
                <span>Subject</span>
                <span>{data.subject || '—'}</span>
              </div>
              <div className="summary-row">
                <span>Date</span>
                <span>{data.date || '—'}</span>
              </div>
              <div className="summary-row">
                <span>Recipient</span>
                <span>{data.email_to || '—'}</span>
              </div>
              <div className="summary-row">
                <span>Student</span>
                <span>{data.student_name || '—'}</span>
              </div>
              <div className="summary-row">
                <span>Student CIN</span>
                <span>{data.student_cin || '—'}</span>
              </div>
            </div>
          </Card>

          <Card title="Email Body">
            <div className="email-body">
              {data.contents || 'No email content recorded.'}
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
